import { render, staticRenderFns } from "./KPIComparisonGroup.vue?vue&type=template&id=8225ba04&"
import script from "./KPIComparisonGroup.vue?vue&type=script&lang=js&"
export * from "./KPIComparisonGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QInnerLoading,QSpinnerTail} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QInnerLoading,QSpinnerTail})
